import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connect } from './redux/blockchain/blockchainActions';
import { fetchData } from './redux/data/dataActions';
import * as s from './styles/globalStyles';
import styled from 'styled-components';

const axios = require('axios');

const truncate = (input, len) =>
	input.length > len ? `${input.substring(0, len)}...` : input;

export const StyledButton = styled.button`
	margin: 30px;
	border: solid;
	background-color: Black;
	padding: 10px;
	font-weight: bold;
	color: var(--secondary-text);
	width: 100px;
	cursor: pointer;
`;

export const StyledRoundButton = styled.button`
	padding: 20px;
	border: none;
	background-color: var(--primary);
	padding: 20px;
	font-weight: bold;
	font-size: 15px;
	color: var(--primary-text);
	width: 30px;
	height: 30px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
	-webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
	-moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
	:active {
		box-shadow: none;
		-webkit-box-shadow: none;
		-moz-box-shadow: none;
	}
`;

export const ResponsiveWrapper = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	justify-content: stretched;
	align-items: stretched;
	width: 100%;
	@media (min-width: 767px) {
		flex-direction: row;
	}
`;

export const StyledLogo = styled.img`
	width: 200px;
	@media (min-width: 767px) {
		width: 300px;
	}
	transition: width 0.5s;
	transition: height 0.5s;
`;

export const StyledImg = styled.img`
	background-color: var(--accent);

	@media (min-width: 900px) {
		width: 100%;
		height: 100%;
		top: 0;
		bottom: 0;
	}
	@media (min-width: 1000px) {
		width: 150%;
		height: 100%;
		top: 0;
		bottom: 0;
	}
	transition: width 0.5s;
`;

export const StyledLink = styled.a`
	color: var(--secondary);
	text-decoration: none;
`;

export default function Mint() {
	const dispatch = useDispatch();
	const blockchain = useSelector((state) => state.blockchain);
	const data = useSelector((state) => state.data);
	const [claimingNft, setClaimingNft] = useState(false);
	const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);
	const [mintAmount, setMintAmount] = useState(1);
	const [CONFIG, SET_CONFIG] = useState({
		CONTRACT_ADDRESS: '',
		SCAN_LINK: '',
		NETWORK: {
			NAME: '',
			SYMBOL: '',
			ID: 0,
		},
		NFT_NAME: '',
		SYMBOL: '',
		MAX_SUPPLY: 1,
		WEI_COST: 0,
		DISPLAY_COST: 0,
		GAS_LIMIT: 0,
		MARKETPLACE: '',
		MARKETPLACE_LINK: '',
		SHOW_BACKGROUND: false,
	});

	const claimNFTs = async () => {
		await axios.get('https://b2dc.xyz/counterGet').then(function (response) {
			var s = JSON.stringify(response.data[0].counter);
			var d = JSON.parse(s);
			if (d >= CONFIG.THE_END) {
				setFeedback('SOLD OUT');
				setClaimingNft(true);
			} else {
				let cost = CONFIG.WEI_COST;
				let gasLimit = CONFIG.GAS_LIMIT;
				let totalCostWei = String(cost * mintAmount);
				let totalGasLimit = String(gasLimit * mintAmount);
				console.log('Cost: ', totalCostWei);
				console.log('Gas limit: ', totalGasLimit);
				setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
				setClaimingNft(true);
				blockchain.smartContract.methods
					.mint()
					.send({
						gasLimit: String(totalGasLimit),
						to: CONFIG.CONTRACT_ADDRESS,
						from: blockchain.account,
						value: totalCostWei,
					})
					.once('error', (err) => {
						console.log(err);
						setFeedback('Sorry, something went wrong please try again later.');
						setClaimingNft(false);
					})
					.then(axios.put('https://b2dc.xyz/counterPut'))
					.then((receipt) => {
						console.log(receipt);
						setFeedback(
							`WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
						);
						setClaimingNft(false);
						dispatch(fetchData(blockchain.account));
					});
			}
		});
	};

	const decrementMintAmount = () => {
		let newMintAmount = mintAmount - 1;
		if (newMintAmount < 1) {
			newMintAmount = 1;
		}
		setMintAmount(newMintAmount);
	};

	const incrementMintAmount = () => {
		let newMintAmount = mintAmount + 1;
		if (newMintAmount > 20) {
			newMintAmount = 20;
		}
		setMintAmount(newMintAmount);
	};

	const getData = async () => {
		await axios.get('https://b2dc.xyz/counterGet').then(function (response) {
			var s = JSON.stringify(response.data[0].counter);
			var d = JSON.parse(s);
			if (d >= CONFIG.THE_END) {
				setFeedback('SOLD OUT');
				setClaimingNft(true);
			}
			console.log(response.data[0].counter);
			if (blockchain.account !== '' && blockchain.smartContract !== null) {
				dispatch(fetchData(blockchain.account));
			}
		});

		//}

		//console.log(res.data[0].counter);
	};

	const getConfig = async () => {
		const configResponse = await fetch('/config/config.json', {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
		});
		const config = await configResponse.json();
		SET_CONFIG(config);
	};

	useEffect(() => {
		getConfig();
	});

	useEffect(() => {
		getData();
	}, [blockchain.account]);

	return (
		<s.Screen>
			<s.Container
				flex={1}
				ai={'center'}
				style={{ padding: 0, backgroundColor: 'var(--primary)' }}
				image={CONFIG.SHOW_BACKGROUND ? '/config/images/bgh.png' : null}
			>
				<StyledLogo alt={'logo'} src={'/config/images/Hlogo.png'} />
				<ResponsiveWrapper flex={1} style={{ padding: '120px' }} test>
					<s.Container
						flex={2}
						jc={'center'}
						ai={'center'}
						style={{
							padding: 0,
							borderRadius: 0,
						}}
					>
						<s.TextTitle
							style={{
								textAlign: 'center',
								fontSize: 50,
								fontWeight: 'bold',
								color: 'var(--accent-text)',
							}}
						>
							{data.totalSupply} / {CONFIG.MAX_SUPPLY}
						</s.TextTitle>
						<s.TextDescription
							style={{
								textAlign: 'center',
								color: 'var(--primary-text)',
							}}
						>
							<StyledLink target={'_blank'} href={CONFIG.SCAN_LINK}>
								{truncate(CONFIG.CONTRACT_ADDRESS, 15)}
							</StyledLink>
						</s.TextDescription>
						<s.SpacerSmall />
						{Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
							<>
								<s.TextTitle
									style={{ textAlign: 'center', color: 'var(--accent-text)' }}
								>
									The sale has ended.
								</s.TextTitle>
								<s.TextDescription
									style={{ textAlign: 'center', color: 'var(--accent-text)' }}
								>
									You can still find {CONFIG.NFT_NAME} on
								</s.TextDescription>
								<s.SpacerSmall />
								<StyledLink target={'_blank'} href={CONFIG.MARKETPLACE_LINK}>
									{CONFIG.MARKETPLACE}
								</StyledLink>
							</>
						) : (
							<>
								<s.TextTitle
									style={{ textAlign: 'center', color: 'var(--accent-text)' }}
								>
									1 {CONFIG.SYMBOL} costs {CONFIG.DISPLAY_COST}{' '}
									{CONFIG.NETWORK.SYMBOL}.
								</s.TextTitle>
								<s.SpacerXSmall />
								<s.TextDescription
									style={{ textAlign: 'center', color: 'var(--accent-text)' }}
								>
									Excluding gas fees.
								</s.TextDescription>
								<s.SpacerSmall />
								{blockchain.account === '' ||
								blockchain.smartContract === null ? (
									<s.Container ai={'center'} jc={'center'}>
										<s.TextDescription
											style={{
												textAlign: 'center',
												color: 'var(--accent-text)',
											}}
										>
											Connect to the {CONFIG.NETWORK.NAME} network
										</s.TextDescription>
										<s.SpacerSmall />
										<StyledButton
											onClick={(e) => {
												e.preventDefault();
												dispatch(connect());
												getData();
											}}
										>
											CONNECT
										</StyledButton>
										{blockchain.errorMsg !== '' ? (
											<>
												<s.SpacerSmall />
												<s.TextDescription
													style={{
														textAlign: 'center',
														color: 'var(--accent-text)',
													}}
												>
													{blockchain.errorMsg}
												</s.TextDescription>
											</>
										) : null}
									</s.Container>
								) : (
									<>
										<s.TextDescription
											style={{
												textAlign: 'center',
												color: 'var(--accent-text)',
											}}
										>
											{feedback}
										</s.TextDescription>
										<s.SpacerMedium />
										<s.Container
											ai={'center'}
											jc={'center'}
											fd={'row'}
										></s.Container>
										<s.SpacerSmall />
										<s.Container ai={'center'} jc={'center'} fd={'row'}>
											<StyledButton
												disabled={claimingNft ? 1 : 0}
												hidden={claimingNft ? 1 : 0}
												onClick={(e) => {
													e.preventDefault();
													claimNFTs();
													getData();
												}}
											>
												{claimingNft ? 'BUSY' : 'BUY'}
											</StyledButton>
										</s.Container>
									</>
								)}
							</>
						)}
					</s.Container>
					<s.SpacerLarge />
					{/* here image  */}
				</ResponsiveWrapper>
				<s.Container jc={'center'} ai={'center'} style={{ marginTop: '10%' }}>
					<s.Container jc={'center'} ai={'center'} style={{ width: '50%' }}>
						<s.TextTitle
							style={{
								textAlign: 'center',
								fontSize: 30,
								fontWeight: 'bold',
								color: 'var(--accent-text)',
								textTransform: 'uppercase',
							}}
						>
							Reminder:
						</s.TextTitle>
						<s.SpacerMedium />
						<s.TextDescription
							style={{
								textAlign: 'center',
								color: 'var(--primary-text)',
							}}
						>
							Please make sure you are connected to the correct network
							(ETHEREUM MAINNET) and the correct address. Please note: Once you
							make your purchase, you cannot undo this action.
							<br />
							<s.SpacerMedium /> Every time a Dead Bois is purchased, 10% of
							that sale is given to a random holder
							<br /> On reveal date, one lucky holder will be awarded 10% of the
							total amount of ETH accrued from all sales of the B2DC project In
							other words.... this is one of those times it PAYS to be early!!!
							<br /> The holders of the NFT also hold EXCLUSIVE PRODUCTION
							COPYRIGHTS meaning so long as you hold this NFT you have the right
							to create any physical product such as sticker, mugs, shirts,
							poster, etc.
							<br />
							Legendary Dead Bois will come with a free tattoo of that legendary
							NFT by Javier Antunez from Tattooed Theory <br />
							<s.SpacerMedium /> Reveal Date: 01/07/2022
							<br />
							<s.SpacerMedium />
							REVEAL OF HIDDEN NFTS AND MEGA LOTTERY ON REVEAL DAY! <br />
							<s.SpacerMedium />
							ALWAYS BE SURE THAT ITS THIS CONTRACT BELOW TO AVOID BEING SCAMMED
							<br /> <s.SpacerMedium />
							Contract: 0x664c52a8be09134d7f92701ebc12f34772e97474
							<br /> <s.SpacerMedium />
							we have set the gas limit to 300000 for the contract to
							successfully mint your NFT. We recommend that you don't lower gas
							limit.
							<br /> Join our discord and show off your Board 2 Death
						</s.TextDescription>
						<s.SpacerSmall />

						<s.SpacerMedium />
						<s.SpacerMedium />
					</s.Container>
				</s.Container>
				<s.SpacerMedium />
				<s.SpacerMedium />
				<s.SpacerMedium />
			</s.Container>
		</s.Screen>
	);
}
